'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';

const HashScrollHandler = () => {
  const pathname = usePathname();

  useEffect(() => {
    const hash = window.location.hash;
    if (!hash) return;

    const id = hash.replace('#', '');
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const scrollToElement = (el: Element) => {
      el.scrollIntoView({ behavior: prefersReducedMotion ? 'instant' : 'smooth', block: 'start' });
    };

    const el = document.getElementById(id);
    if (el) {
      const timer = setTimeout(() => scrollToElement(el), 100);
      return () => clearTimeout(timer);
    }

    const observer = new MutationObserver(() => {
      const target = document.getElementById(id);
      if (target) {
        observer.disconnect();
        scrollToElement(target);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, [pathname]);

  return null;
};

export default HashScrollHandler;
